/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：/TF1__part-0
 */

"use strict"

/* harmony export (binding) */
/* harmony import */
import * as __WEBPACK_IMPORTED_MODULE_0_react__ from /* GiK3 */"react"
/* harmony import */
import __WEBPACK_IMPORTED_MODULE_0_react___default from /* GiK3 */"react"
/* harmony import */
import * as __WEBPACK_IMPORTED_MODULE_1_react_css_modules__ from /* 211U */"react-css-modules"
/* harmony import */
import __WEBPACK_IMPORTED_MODULE_1_react_css_modules___default from /* 211U */"react-css-modules"
/* harmony import */
import * as __WEBPACK_IMPORTED_MODULE_2_classnames__ from /* HW6M */"classnames"
/* harmony import */
import __WEBPACK_IMPORTED_MODULE_2_classnames___default from /* HW6M */"classnames"
/* harmony import */
import * as __WEBPACK_IMPORTED_MODULE_3__Dialog__ from /* kQfo */"./Dialog-kQfo"
/* harmony import */
import * as __WEBPACK_IMPORTED_MODULE_4__Button__ from /* XdPl */"./Button-XdPl"
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i]
      descriptor.enumerable = descriptor.enumerable || false
      descriptor.configurable = true
      if ("value" in descriptor) {
        descriptor.writable = true
      }
      Object.defineProperty(target, descriptor.key, descriptor)
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) {
      defineProperties(Constructor.prototype, protoProps)
    }
    if (staticProps) {
      defineProperties(Constructor, staticProps)
    }
    return Constructor
  }
}()
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function")
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called")
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass)
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  })
  if (superClass) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(subClass, superClass)
    } else {
      subClass.__proto__ = superClass
    }
  }
}
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var /* [auto-meaningful-name] */arguments$length = arguments.length
  var r = arguments$length < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc
  var d
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") {
    r = Reflect.decorate(decorators, target, key, desc)
  } else {
    for (var i = decorators.length - 1; i >= 0; i--) {
      if (d = decorators[i]) {
        r = (arguments$length < 3 ? d(r) : arguments$length > 3 ? d(target, key, r) : d(target, key)) || r
      }
    }
  }
  if (arguments$length > 3 && r) {
    Object.defineProperty(target, key, r)
  }
  return r
}
export { _createClass }
export { _classCallCheck }
export { _possibleConstructorReturn }
export { _inherits }
export { __decorate }
